import { Row, Col, Form } from "react-bootstrap";
import { Divider, p } from "@mui/material";

export const CostBreakdown = ({
    helperRate,
    helperServiceFee,
    customerServiceFee, 
    hours
}) => {

  const getHelperTotal = (hours) => {
    const subtotal = helperRate * hours;
    const fee = subtotal * (helperServiceFee / 100);
    const total = subtotal - fee;
    return {
      subtotal: subtotal.toFixed(2),
      fee: fee.toFixed(2),
      total: total.toFixed(2)
    }
  }

  const getCustomerTotal = (hours) => {
    const subtotal = helperRate * hours;
    const fee = subtotal * (customerServiceFee / 100);
    const total = subtotal + fee;
    return {
      subtotal: subtotal.toFixed(2),
      fee: fee.toFixed(2),
      total: total.toFixed(2)
          }
  }

  return (
    <> 
      <Row>
        <Col>
            <Form.Label>Helper</Form.Label>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <p>Subtotal</p>
          <p>${getHelperTotal(hours).subtotal}</p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <p>Fee ({helperServiceFee}%)</p>
          <p>- ${getHelperTotal(hours).fee}</p>
        </Col>
      </Row>
      <Divider sx={{mt: 1, mb: 2}} />
      <Row>
        <Col className="d-flex justify-content-between">
          <p>Total</p>
          <p sx={{mb: 4}}>${getHelperTotal(hours).total}</p>
        </Col>
      </Row>
      <Row>
        <Col>
            <Form.Label style={{marginTop: '24px'}}>Customer</Form.Label>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <p>Subtotal</p>
          <p>${getCustomerTotal(hours).subtotal}</p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <p>Fee ({customerServiceFee}%)</p>
          <p>${getCustomerTotal(hours).fee}</p>
        </Col>
      </Row>
      <Divider sx={{mt: 1, mb: 2}} />
      <Row>
        <Col className="d-flex justify-content-between">
          <p>Total</p>
          <p>${getCustomerTotal(hours).total}</p>
        </Col>
      </Row>
    </>
  )
};